
import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation('common');

  return (
    <section
      className="relative bg-cover bg-center h-[60vh] md:h-[70vh] lg:h-screen flex items-center"
      style={{
        backgroundImage: 'url(https://public.readdy.ai/ai/img_res/dc876c01cef947847922f25938758f4d.jpg)',
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/40"></div>
      
      <div className="container mx-auto px-3 md:px-6 relative z-10 w-full">
        <div className="max-w-xl md:max-w-2xl lg:max-w-3xl">
          <h1 className="text-2xl md:text-4xl lg:text-6xl font-bold text-white mb-3 md:mb-6 leading-tight">
            {t('hero.title')}
          </h1>
          <p className="text-xs md:text-base lg:text-xl text-gray-200 mb-4 md:mb-8 leading-relaxed">
            {t('hero.subtitle')}
          </p>
        </div>
      </div>
    </section>
  );
}
